import { render, staticRenderFns } from "./swiper_first_scend_tab02.vue?vue&type=template&id=f447400e"
import script from "./swiper_first_scend_tab02.vue?vue&type=script&lang=js"
export * from "./swiper_first_scend_tab02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports